import { getShares } from '../api/cloudShare';
import { getPlaylistCovers } from '../digitalVault';
import { shareResponseParser } from '../utils';
const getSharesList = async (props, cursor, logger) => {
    const { count, filter } = props;
    const urlParams = new URLSearchParams([
        ['filter', filter],
        ['count', count.toString()],
    ]);
    if (cursor) {
        urlParams.append('cursor', cursor);
    }
    const { shares, links } = await getShares(`?${urlParams.toString()}`, {}, logger);
    const parsedData = (shares && shareResponseParser(shares)) || [];
    const data = parsedData.filter((item) => item?.uri !== undefined);
    const next = links?.find((item) => item.rel === 'next')?.href || false;
    let nextPage = '';
    if (next) {
        const params = new URL(next);
        nextPage = params.searchParams.get('cursor');
    }
    const playlist = data?.length &&
        data?.filter((item) => {
            const origianlItem = item.originalItem;
            return (origianlItem.resourceSummaryGroups?.length === 1 &&
                origianlItem.resourceSummaryGroups[0].type === 'playlist');
        });
    playlist.length && getPlaylistCovers(playlist, 'getShares');
    return {
        data,
        hasNextPage: !!nextPage,
        paginate() {
            return !!nextPage && getSharesList({ count, filter }, nextPage, logger);
        },
    };
};
export default getSharesList;
